import React, { Component } from 'react';
import 'react-table/react-table.css';
import Pagination from '../component/Pagination.js';

function Row({ data }) {
  const dataArray = Object.values(data);
  return (
    <tr>
      {dataArray.map(value => {
        return <td>{value}</td>;
      })}
    </tr>
  );
}

export class TableRiwayatOdontogram extends Component {
  state = {
    currentPage: 1
  };

  handlePageChange = pageNumber => {
    this.setState({
      currentPage: pageNumber
    });
  };

  render() {
    const currentPage = this.state.currentPage;
    const { headers } = this.props;
    const data = this.props.data
      ? this.props.data.map(this.props.columnMapper)
      : [];
    const indexOfLastPost = this.state.currentPage * 5;
    const indexOfFirstPost = indexOfLastPost - 5;
    const currentLists = data
      ? data.slice(indexOfFirstPost, indexOfLastPost)
      : null;

    return (
      <div>
        <div className="card-header bg-success">
          <h4 className="text-white my--2"> Riwayat </h4>
        </div>
        <div className="table-responsive">
          <table className="table align-items-center table-flush">
            <thead className="thead-light">
              <tr>
                {headers.map((header, i) => {
                  return (
                    <th key={ i } scope="col" className="sort">
                      {header}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="list">
              {currentLists.length > 0 ? (
                currentLists.map((currentList, i) => {
                  return <Row key={ currentList.id } data={ currentList } />;
                })
              ) : (
                <tr>
                  <td colSpan={ headers.length } style={ { textAlign: 'center' } }>
                    tidak ada data..
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {currentLists && (
            <Pagination
              listsPerPage={ 5 }
              totalLists={ currentLists && currentLists.length }
              handlePageChange={ this.handlePageChange }
              currentPage={ currentPage }
            />
          )}
        </div>
      </div>
    );
  }
}

export default TableRiwayatOdontogram;
